"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.highlightCodeBlocks = highlightCodeBlocks;
exports.parseInlineHighlightMarkers = parseInlineHighlightMarkers;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _common = require("@insided/shared/utils/common");

var _clipboard = _interopRequireDefault(require("@insided/deprecated-utils/clipboard"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var TOOLTIP_DURATION = 1000;
var hljsInstance = null;
var loadingPromise = null;
var loadedLanguages = new Set();
var tooltipTimeoutId = null;
var copiedTimeoutId = null; // Language mapping for dynamic imports

var languageMap = {
  apache: function () {
    var _apache = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", import('highlight.js/lib/languages/apache'));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function apache() {
      return _apache.apply(this, arguments);
    }

    return apache;
  }(),
  bash: function () {
    var _bash = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", import('highlight.js/lib/languages/bash'));

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function bash() {
      return _bash.apply(this, arguments);
    }

    return bash;
  }(),
  c: function () {
    var _c = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
      return _regenerator.default.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", import('highlight.js/lib/languages/c'));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function c() {
      return _c.apply(this, arguments);
    }

    return c;
  }(),
  'c#': function () {
    var _c2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
      return _regenerator.default.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              return _context4.abrupt("return", import('highlight.js/lib/languages/csharp'));

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function c() {
      return _c2.apply(this, arguments);
    }

    return c;
  }(),
  csharp: function () {
    var _csharp = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5() {
      return _regenerator.default.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              return _context5.abrupt("return", import('highlight.js/lib/languages/csharp'));

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function csharp() {
      return _csharp.apply(this, arguments);
    }

    return csharp;
  }(),
  css: function () {
    var _css = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6() {
      return _regenerator.default.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt("return", import('highlight.js/lib/languages/css'));

            case 1:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function css() {
      return _css.apply(this, arguments);
    }

    return css;
  }(),
  diff: function () {
    var _diff = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7() {
      return _regenerator.default.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              return _context7.abrupt("return", import('highlight.js/lib/languages/diff'));

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    function diff() {
      return _diff.apply(this, arguments);
    }

    return diff;
  }(),
  html: function () {
    var _html = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8() {
      return _regenerator.default.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              return _context8.abrupt("return", import('highlight.js/lib/languages/xml'));

            case 1:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    function html() {
      return _html.apply(this, arguments);
    }

    return html;
  }(),
  http: function () {
    var _http = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee9() {
      return _regenerator.default.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              return _context9.abrupt("return", import('highlight.js/lib/languages/http'));

            case 1:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    function http() {
      return _http.apply(this, arguments);
    }

    return http;
  }(),
  ini: function () {
    var _ini = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee10() {
      return _regenerator.default.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", import('highlight.js/lib/languages/ini'));

            case 1:
            case "end":
              return _context10.stop();
          }
        }
      }, _callee10);
    }));

    function ini() {
      return _ini.apply(this, arguments);
    }

    return ini;
  }(),
  java: function () {
    var _java = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee11() {
      return _regenerator.default.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              return _context11.abrupt("return", import('highlight.js/lib/languages/java'));

            case 1:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee11);
    }));

    function java() {
      return _java.apply(this, arguments);
    }

    return java;
  }(),
  javascript: function () {
    var _javascript = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee12() {
      return _regenerator.default.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              return _context12.abrupt("return", import('highlight.js/lib/languages/javascript'));

            case 1:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }));

    function javascript() {
      return _javascript.apply(this, arguments);
    }

    return javascript;
  }(),
  json: function () {
    var _json = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee13() {
      return _regenerator.default.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              return _context13.abrupt("return", import('highlight.js/lib/languages/json'));

            case 1:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee13);
    }));

    function json() {
      return _json.apply(this, arguments);
    }

    return json;
  }(),
  makefile: function () {
    var _makefile = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee14() {
      return _regenerator.default.wrap(function _callee14$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              return _context14.abrupt("return", import('highlight.js/lib/languages/makefile'));

            case 1:
            case "end":
              return _context14.stop();
          }
        }
      }, _callee14);
    }));

    function makefile() {
      return _makefile.apply(this, arguments);
    }

    return makefile;
  }(),
  markdown: function () {
    var _markdown = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee15() {
      return _regenerator.default.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              return _context15.abrupt("return", import('highlight.js/lib/languages/markdown'));

            case 1:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee15);
    }));

    function markdown() {
      return _markdown.apply(this, arguments);
    }

    return markdown;
  }(),
  nginx: function () {
    var _nginx = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee16() {
      return _regenerator.default.wrap(function _callee16$(_context16) {
        while (1) {
          switch (_context16.prev = _context16.next) {
            case 0:
              return _context16.abrupt("return", import('highlight.js/lib/languages/nginx'));

            case 1:
            case "end":
              return _context16.stop();
          }
        }
      }, _callee16);
    }));

    function nginx() {
      return _nginx.apply(this, arguments);
    }

    return nginx;
  }(),
  objectivec: function () {
    var _objectivec = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee17() {
      return _regenerator.default.wrap(function _callee17$(_context17) {
        while (1) {
          switch (_context17.prev = _context17.next) {
            case 0:
              return _context17.abrupt("return", import('highlight.js/lib/languages/objectivec'));

            case 1:
            case "end":
              return _context17.stop();
          }
        }
      }, _callee17);
    }));

    function objectivec() {
      return _objectivec.apply(this, arguments);
    }

    return objectivec;
  }(),
  perl: function () {
    var _perl = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee18() {
      return _regenerator.default.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              return _context18.abrupt("return", import('highlight.js/lib/languages/perl'));

            case 1:
            case "end":
              return _context18.stop();
          }
        }
      }, _callee18);
    }));

    function perl() {
      return _perl.apply(this, arguments);
    }

    return perl;
  }(),
  powershell: function () {
    var _powershell = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee19() {
      return _regenerator.default.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              return _context19.abrupt("return", import('highlight.js/lib/languages/powershell'));

            case 1:
            case "end":
              return _context19.stop();
          }
        }
      }, _callee19);
    }));

    function powershell() {
      return _powershell.apply(this, arguments);
    }

    return powershell;
  }(),
  php: function () {
    var _php = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee20() {
      return _regenerator.default.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              return _context20.abrupt("return", import('highlight.js/lib/languages/php'));

            case 1:
            case "end":
              return _context20.stop();
          }
        }
      }, _callee20);
    }));

    function php() {
      return _php.apply(this, arguments);
    }

    return php;
  }(),
  python: function () {
    var _python = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee21() {
      return _regenerator.default.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              return _context21.abrupt("return", import('highlight.js/lib/languages/python'));

            case 1:
            case "end":
              return _context21.stop();
          }
        }
      }, _callee21);
    }));

    function python() {
      return _python.apply(this, arguments);
    }

    return python;
  }(),
  ruby: function () {
    var _ruby = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee22() {
      return _regenerator.default.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              return _context22.abrupt("return", import('highlight.js/lib/languages/ruby'));

            case 1:
            case "end":
              return _context22.stop();
          }
        }
      }, _callee22);
    }));

    function ruby() {
      return _ruby.apply(this, arguments);
    }

    return ruby;
  }(),
  sql: function () {
    var _sql = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee23() {
      return _regenerator.default.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              return _context23.abrupt("return", import('highlight.js/lib/languages/sql'));

            case 1:
            case "end":
              return _context23.stop();
          }
        }
      }, _callee23);
    }));

    function sql() {
      return _sql.apply(this, arguments);
    }

    return sql;
  }(),
  swift: function () {
    var _swift = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee24() {
      return _regenerator.default.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              return _context24.abrupt("return", import('highlight.js/lib/languages/swift'));

            case 1:
            case "end":
              return _context24.stop();
          }
        }
      }, _callee24);
    }));

    function swift() {
      return _swift.apply(this, arguments);
    }

    return swift;
  }(),
  vbscript: function () {
    var _vbscript = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee25() {
      return _regenerator.default.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              return _context25.abrupt("return", import('highlight.js/lib/languages/vbscript'));

            case 1:
            case "end":
              return _context25.stop();
          }
        }
      }, _callee25);
    }));

    function vbscript() {
      return _vbscript.apply(this, arguments);
    }

    return vbscript;
  }(),
  xml: function () {
    var _xml = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee26() {
      return _regenerator.default.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              return _context26.abrupt("return", import('highlight.js/lib/languages/xml'));

            case 1:
            case "end":
              return _context26.stop();
          }
        }
      }, _callee26);
    }));

    function xml() {
      return _xml.apply(this, arguments);
    }

    return xml;
  }(),
  xhtml: function () {
    var _xhtml = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee27() {
      return _regenerator.default.wrap(function _callee27$(_context27) {
        while (1) {
          switch (_context27.prev = _context27.next) {
            case 0:
              return _context27.abrupt("return", import('highlight.js/lib/languages/xml'));

            case 1:
            case "end":
              return _context27.stop();
          }
        }
      }, _callee27);
    }));

    function xhtml() {
      return _xhtml.apply(this, arguments);
    }

    return xhtml;
  }(),
  typescript: function () {
    var _typescript = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee28() {
      return _regenerator.default.wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              return _context28.abrupt("return", import('highlight.js/lib/languages/typescript'));

            case 1:
            case "end":
              return _context28.stop();
          }
        }
      }, _callee28);
    }));

    function typescript() {
      return _typescript.apply(this, arguments);
    }

    return typescript;
  }(),
  yaml: function () {
    var _yaml = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee29() {
      return _regenerator.default.wrap(function _callee29$(_context29) {
        while (1) {
          switch (_context29.prev = _context29.next) {
            case 0:
              return _context29.abrupt("return", import('highlight.js/lib/languages/yaml'));

            case 1:
            case "end":
              return _context29.stop();
          }
        }
      }, _callee29);
    }));

    function yaml() {
      return _yaml.apply(this, arguments);
    }

    return yaml;
  }(),
  yml: function () {
    var _yml = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee30() {
      return _regenerator.default.wrap(function _callee30$(_context30) {
        while (1) {
          switch (_context30.prev = _context30.next) {
            case 0:
              return _context30.abrupt("return", import('highlight.js/lib/languages/yaml'));

            case 1:
            case "end":
              return _context30.stop();
          }
        }
      }, _callee30);
    }));

    function yml() {
      return _yml.apply(this, arguments);
    }

    return yml;
  }(),
  yara: function () {
    var _yara = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee31() {
      return _regenerator.default.wrap(function _callee31$(_context31) {
        while (1) {
          switch (_context31.prev = _context31.next) {
            case 0:
              return _context31.abrupt("return", import('./languages/yara'));

            case 1:
            case "end":
              return _context31.stop();
          }
        }
      }, _callee31);
    }));

    function yara() {
      return _yara.apply(this, arguments);
    }

    return yara;
  }()
};

function loadHljs() {
  return _loadHljs.apply(this, arguments);
}

function _loadHljs() {
  _loadHljs = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee33() {
    return _regenerator.default.wrap(function _callee33$(_context33) {
      while (1) {
        switch (_context33.prev = _context33.next) {
          case 0:
            if (!hljsInstance) {
              _context33.next = 2;
              break;
            }

            return _context33.abrupt("return", hljsInstance);

          case 2:
            if (!loadingPromise) {
              _context33.next = 4;
              break;
            }

            return _context33.abrupt("return", loadingPromise);

          case 4:
            loadingPromise = import('highlight.js/lib/core').then(function (module) {
              hljsInstance = module.default;
              return hljsInstance;
            });
            return _context33.abrupt("return", loadingPromise);

          case 6:
          case "end":
            return _context33.stop();
        }
      }
    }, _callee33);
  }));
  return _loadHljs.apply(this, arguments);
}

function loadLanguage(_x) {
  return _loadLanguage.apply(this, arguments);
}

function _loadLanguage() {
  _loadLanguage = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee34(language) {
    var loader, languageModule;
    return _regenerator.default.wrap(function _callee34$(_context34) {
      while (1) {
        switch (_context34.prev = _context34.next) {
          case 0:
            if (!(!hljsInstance || loadedLanguages.has(language))) {
              _context34.next = 2;
              break;
            }

            return _context34.abrupt("return");

          case 2:
            loader = languageMap[language.toLowerCase()];

            if (loader) {
              _context34.next = 5;
              break;
            }

            return _context34.abrupt("return");

          case 5:
            _context34.prev = 5;
            _context34.next = 8;
            return loader();

          case 8:
            languageModule = _context34.sent;
            hljsInstance.registerLanguage(language, languageModule.default);
            loadedLanguages.add(language);
            _context34.next = 17;
            break;

          case 13:
            _context34.prev = 13;
            _context34.t0 = _context34["catch"](5);
            console.warn("Failed to load language: ".concat(language), _context34.t0);
            return _context34.abrupt("return", _context34.t0);

          case 17:
          case "end":
            return _context34.stop();
        }
      }
    }, _callee34, null, [[5, 13]]);
  }));
  return _loadLanguage.apply(this, arguments);
}

function parseInlineHighlightMarkers(text) {
  var highlightPattern = /\/\/\[highlight]\s*$/;
  var inlineLines = new Map();
  var cleaned = (text || '').split('\n').map(function (line, idx) {
    if (highlightPattern.test(line)) {
      inlineLines.set(idx + 1, 'highlight');
      return line.replace(highlightPattern, '').trimEnd();
    }

    return line;
  });
  return {
    cleanedText: cleaned.join('\n'),
    inlineLines: inlineLines
  };
}

function ensureOnce(node, id) {
  if (document.getElementById(id)) return;
  node.id = id;
  document.head.appendChild(node);
}

function getIsDarkTheme() {
  return _common.common.isModuleActive('codeSnippetDarkTheme');
}

function ensureSyntaxThemeLoaded() {
  var _iterator = _createForOfIteratorHelper(document.querySelectorAll('link[rel="stylesheet"][href*="highlight.js"][href*="/styles/"]')),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var link = _step.value;
      var el = link;
      if (el.id !== 'hljs-theme-syntax') el.remove();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var isDark = getIsDarkTheme();
  var body = document.body;

  if (isDark) {
    body.classList.add('dark-theme');
  } else {
    body.classList.remove('dark-theme');
  }
}

function ensureHighlightAssetsLoaded(_x2) {
  return _ensureHighlightAssetsLoaded.apply(this, arguments);
}

function _ensureHighlightAssetsLoaded() {
  _ensureHighlightAssetsLoaded = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee35(onReady) {
    return _regenerator.default.wrap(function _callee35$(_context35) {
      while (1) {
        switch (_context35.prev = _context35.next) {
          case 0:
            _context35.prev = 0;
            _context35.next = 3;
            return loadHljs();

          case 3:
            ensureSyntaxThemeLoaded();
            onReady();
            _context35.next = 11;
            break;

          case 7:
            _context35.prev = 7;
            _context35.t0 = _context35["catch"](0);
            console.warn('Failed to load highlight.js assets', _context35.t0);
            onReady(); // Still call onReady to prevent blocking the UI

          case 11:
          case "end":
            return _context35.stop();
        }
      }
    }, _callee35, null, [[0, 7]]);
  }));
  return _ensureHighlightAssetsLoaded.apply(this, arguments);
}

function getLanguageFromClasses(codeElement) {
  var _codeElement$getAttri;

  var classAttr = (_codeElement$getAttri = codeElement.getAttribute('class')) !== null && _codeElement$getAttri !== void 0 ? _codeElement$getAttri : '';
  var re = /(?:language|lang)-([a-z0-9+-]+)/i;
  var match = re.exec(classAttr);
  return match ? match[1].toLowerCase() : null;
}

function injectLineNumberStyles() {
  var isDark = getIsDarkTheme();
  var codeBg = isDark ? '#282c34' : '#f6f6f6';
  var codeFg = isDark ? '#abb2bf' : '#24292e';
  var defaultHlBg = isDark ? 'rgba(62,68,81,0.35)' : 'rgba(255,243,205,0.8)';
  var style = document.createElement('style');
  style.textContent = [".styled-code-block code.hljs{display:block;background-color:".concat(codeBg, "!important;color:").concat(codeFg, "!important;border-radius:8px;padding:0.5em;}"), '.code-line{display:flex;align-items:flex-start;min-height:1.2em;}', '.line-num{color:#636d83;text-align:right;min-width:3em;padding-right:1em;border-right:1px solid #4b5263;margin-right:1em;flex-shrink:0;-webkit-user-select:none;-moz-user-select:none;user-select:none;}', ".code-line.highlight{background-color:".concat(defaultHlBg, ";font-weight:bold;}")].join('');
  ensureOnce(style, 'hljs-line-number-styles');
}

function injectCopyButtonStyles() {
  var isDark = getIsDarkTheme();
  var buttonBg = isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)';
  var buttonBorder = isDark ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.15)';
  var buttonHoverBg = isDark ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)';
  var buttonActiveBg = isDark ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.15)';
  var iconColor = isDark ? '#fff' : '#24292e';
  var style = document.createElement('style');
  style.textContent = ['.styled-code-block{position:relative;}', ".code-copy-button{position:absolute;top:4px;right:4px;padding:6px;background:".concat(buttonBg, ";border:1px solid ").concat(buttonBorder, ";border-radius:4px;cursor:pointer;opacity:0.7;transition:opacity 0.2s,background 0.2s;display:flex;align-items:center;justify-content:center;}"), ".code-copy-button:hover{opacity:1;background:".concat(buttonHoverBg, ";}"), ".code-copy-button:active{background:".concat(buttonActiveBg, ";}"), ".code-copy-button svg{width:16px;height:16px;color:".concat(iconColor, ";display:block;}"), '.styled-code-block .copy-tooltip{position:absolute;top:-30px;right:4px;background:rgba(0,0,0,0.9);color:#fff;padding:4px 8px;border-radius:4px;font-size:12px;white-space:nowrap;opacity:0;pointer-events:none;transition:opacity 0.2s;}', '.styled-code-block .copy-tooltip.show{opacity:1;}'].join('');
  ensureOnce(style, 'hljs-copy-button-styles');
}

function createCopyIcon() {
  return "<svg width=\"16\" height=\"16\" viewBox=\"0 0 24 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" role=\"img\" aria-hidden=\"true\" focusable=\"false\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M9 11.0137C9 9.9091 9.89543 9.01367 11 9.01367H20C21.1046 9.01367 22 9.9091 22 11.0137V20.0137C22 21.1182 21.1046 22.0137 20 22.0137H11C9.89543 22.0137 9 21.1182 9 20.0137V11.0137Z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    <path d=\"M5 15.0137H4C2.89543 15.0137 2 14.1182 2 13.0137V4.01367C2 2.9091 2.89543 2.01367 4 2.01367H13C14.1046 2.01367 15 2.9091 15 4.01367V5.01367\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  </svg>";
}

function showTooltip(preElement, message) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : TOOLTIP_DURATION;
  var tooltip = preElement.querySelector('.copy-tooltip');

  if (!tooltip) {
    tooltip = document.createElement('div');
    tooltip.className = 'copy-tooltip';
    preElement.appendChild(tooltip);
  }

  tooltip.textContent = message;
  tooltip.classList.add('show');

  if (tooltipTimeoutId) {
    clearTimeout(tooltipTimeoutId);
    tooltipTimeoutId = null;
  }

  tooltipTimeoutId = setTimeout(function () {
    tooltip.classList.remove('show');
    tooltipTimeoutId = null;
  }, duration);
}

function createCopyButton(codeText, preElement) {
  var button = document.createElement('button');
  button.className = 'code-copy-button';
  button.setAttribute('aria-label', 'Copy code to clipboard');
  button.type = 'button';
  button.innerHTML = createCopyIcon();

  button.onclick = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee32(e) {
      return _regenerator.default.wrap(function _callee32$(_context32) {
        while (1) {
          switch (_context32.prev = _context32.next) {
            case 0:
              e.preventDefault();
              e.stopPropagation();
              _context32.prev = 2;
              _context32.next = 5;
              return (0, _clipboard.default)(codeText);

            case 5:
              button.classList.add('copied');
              showTooltip(preElement, 'Copied!');

              if (copiedTimeoutId) {
                clearTimeout(copiedTimeoutId);
                copiedTimeoutId = null;
              }

              copiedTimeoutId = setTimeout(function () {
                button.classList.remove('copied');
                copiedTimeoutId = null;
              }, TOOLTIP_DURATION);
              _context32.next = 15;
              break;

            case 11:
              _context32.prev = 11;
              _context32.t0 = _context32["catch"](2);
              console.error('Failed to copy code to clipboard', _context32.t0);
              showTooltip(preElement, 'Failed to copy');

            case 15:
            case "end":
              return _context32.stop();
          }
        }
      }, _callee32, null, [[2, 11]]);
    }));

    return function (_x3) {
      return _ref.apply(this, arguments);
    };
  }();

  return button;
}

function addCopyButtonToCodeBlock(codeElement, originalText) {
  var preElement = codeElement.closest('pre');
  if (!preElement) return;
  if (preElement.querySelector('.code-copy-button')) return;
  var copyButton = createCopyButton(originalText, preElement);
  preElement.appendChild(copyButton);
}

function preparePreWrapper(codeElement) {
  var pre = codeElement.closest('pre');

  if (!pre) {
    pre = document.createElement('pre');
    codeElement.before(pre);
    pre.appendChild(codeElement);
  }

  if (!pre.classList.contains('styled-code-block')) pre.classList.add('styled-code-block');
  codeElement.classList.add('hljs');
}

function computeHighlightedHTML(_x4, _x5, _x6, _x7) {
  return _computeHighlightedHTML.apply(this, arguments);
}

function _computeHighlightedHTML() {
  _computeHighlightedHTML = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee36(hl, cleanedText, language, codeElement) {
    var normalizedLanguage;
    return _regenerator.default.wrap(function _callee36$(_context36) {
      while (1) {
        switch (_context36.prev = _context36.next) {
          case 0:
            _context36.prev = 0;

            if (!language) {
              _context36.next = 8;
              break;
            }

            normalizedLanguage = language.toLowerCase();

            if (!(normalizedLanguage in languageMap)) {
              _context36.next = 7;
              break;
            }

            _context36.next = 6;
            return loadLanguage(language);

          case 6:
            return _context36.abrupt("return", hl.highlight(cleanedText, {
              language: language,
              ignoreIllegals: true
            }).value);

          case 7:
            return _context36.abrupt("return", cleanedText);

          case 8:
            return _context36.abrupt("return", hl.highlightAuto(cleanedText).value);

          case 11:
            _context36.prev = 11;
            _context36.t0 = _context36["catch"](0);
            console.warn('[highlightCodeBlocks] Failed to highlight code block', _context36.t0);
            return _context36.abrupt("return", codeElement.innerHTML);

          case 15:
          case "end":
            return _context36.stop();
        }
      }
    }, _callee36, null, [[0, 11]]);
  }));
  return _computeHighlightedHTML.apply(this, arguments);
}

function renderHighlightedHTML(highlightedHTML, linesToType) {
  var htmlLines = highlightedHTML.split('\n');
  return htmlLines.map(function (htmlLine, index) {
    var _linesToType$get;

    var lineNum = index + 1;
    var klass = (_linesToType$get = linesToType.get(lineNum)) !== null && _linesToType$get !== void 0 ? _linesToType$get : '';
    return '<div class="code-line' + (klass ? ' ' + klass : '') + '">' + '<span class="line-num">' + String(lineNum) + '</span>' + '<span class="line-content">' + htmlLine + '</span>' + '</div>';
  }).join('');
}

function highlightCodeBlocks(_x8) {
  return _highlightCodeBlocks.apply(this, arguments);
}

function _highlightCodeBlocks() {
  _highlightCodeBlocks = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee38(wrapperComponent) {
    var codeBlocks;
    return _regenerator.default.wrap(function _callee38$(_context38) {
      while (1) {
        switch (_context38.prev = _context38.next) {
          case 0:
            codeBlocks = wrapperComponent.querySelectorAll('pre code, code[class^="language-"], code[class*=" language-"]');

            if (codeBlocks.length) {
              _context38.next = 3;
              break;
            }

            return _context38.abrupt("return");

          case 3:
            _context38.next = 5;
            return ensureHighlightAssetsLoaded( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee37() {
              var hl, _iterator2, _step2, _ref3, _codeElement$innerTex, _textLines$at, code, codeElement, language, originalText, linesToType, _parseInlineHighlight, cleanedText, inlineLines, _iterator3, _step3, _ref4, _linesToType$get2, _step3$value, lineNo, type, textLines, highlightedHTML, tempContainer;

              return _regenerator.default.wrap(function _callee37$(_context37) {
                while (1) {
                  switch (_context37.prev = _context37.next) {
                    case 0:
                      injectLineNumberStyles();
                      injectCopyButtonStyles();
                      hl = hljsInstance;

                      if (hl) {
                        _context37.next = 6;
                        break;
                      }

                      console.warn('highlight.js failed to load');
                      return _context37.abrupt("return");

                    case 6:
                      _iterator2 = _createForOfIteratorHelper(codeBlocks);
                      _context37.prev = 7;

                      _iterator2.s();

                    case 9:
                      if ((_step2 = _iterator2.n()).done) {
                        _context37.next = 41;
                        break;
                      }

                      code = _step2.value;
                      codeElement = code;

                      if (!(codeElement.dataset.hlProcessed === '1')) {
                        _context37.next = 14;
                        break;
                      }

                      return _context37.abrupt("continue", 39);

                    case 14:
                      preparePreWrapper(codeElement);
                      language = getLanguageFromClasses(codeElement);
                      originalText = (_ref3 = (_codeElement$innerTex = codeElement.innerText) !== null && _codeElement$innerTex !== void 0 ? _codeElement$innerTex : codeElement.textContent) !== null && _ref3 !== void 0 ? _ref3 : '';
                      linesToType = new Map();
                      _parseInlineHighlight = parseInlineHighlightMarkers(originalText), cleanedText = _parseInlineHighlight.cleanedText, inlineLines = _parseInlineHighlight.inlineLines;
                      _iterator3 = _createForOfIteratorHelper(inlineLines);

                      try {
                        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                          _step3$value = (0, _slicedToArray2.default)(_step3.value, 2), lineNo = _step3$value[0], type = _step3$value[1];
                          linesToType.set(lineNo, (_ref4 = (_linesToType$get2 = linesToType.get(lineNo)) !== null && _linesToType$get2 !== void 0 ? _linesToType$get2 : type) !== null && _ref4 !== void 0 ? _ref4 : 'highlight');
                        }
                      } catch (err) {
                        _iterator3.e(err);
                      } finally {
                        _iterator3.f();
                      }

                      textLines = cleanedText.split('\n');

                      if (textLines.length > 1 && ((_textLines$at = textLines.at(-1)) !== null && _textLines$at !== void 0 ? _textLines$at : '').trim() === '') {
                        textLines.pop();
                      }

                      _context37.prev = 23;
                      _context37.next = 26;
                      return computeHighlightedHTML(hl, cleanedText, language, codeElement);

                    case 26:
                      highlightedHTML = _context37.sent;
                      tempContainer = document.createElement('div');
                      tempContainer.innerHTML = renderHighlightedHTML(highlightedHTML, linesToType);
                      codeElement.textContent = '';

                      while (tempContainer.firstChild) {
                        codeElement.appendChild(tempContainer.firstChild);
                      }

                      codeElement.dataset.hlProcessed = '1';
                      addCopyButtonToCodeBlock(codeElement, cleanedText);
                      _context37.next = 39;
                      break;

                    case 35:
                      _context37.prev = 35;
                      _context37.t0 = _context37["catch"](23);
                      console.warn('Failed to process code highlighting for element', _context37.t0);
                      codeElement.dataset.hlProcessed = '1'; // Mark as processed to prevent infinite retry loops

                    case 39:
                      _context37.next = 9;
                      break;

                    case 41:
                      _context37.next = 46;
                      break;

                    case 43:
                      _context37.prev = 43;
                      _context37.t1 = _context37["catch"](7);

                      _iterator2.e(_context37.t1);

                    case 46:
                      _context37.prev = 46;

                      _iterator2.f();

                      return _context37.finish(46);

                    case 49:
                    case "end":
                      return _context37.stop();
                  }
                }
              }, _callee37, null, [[7, 43, 46, 49], [23, 35]]);
            })));

          case 5:
          case "end":
            return _context38.stop();
        }
      }
    }, _callee38);
  }));
  return _highlightCodeBlocks.apply(this, arguments);
}